import { Box } from '../containers/Container/Box.component';

export const ModalHeader = props => <Box px={6} pt={6} pb={4} {...props} />;

ModalHeader.displayName = 'Modal.Header';
